import React, { useState } from "react";
import { connect } from "react-redux";
import { FiSend } from "react-icons/fi";
import { Button, Form, Input } from "antd";
import { setMicOpen } from "../../store/home/action";
import { sendText, setQuestion } from "../../store/sending/action";

const SpeechV2 = (props) => {
  const {
    onSend = () => {},
    sendLoading,
    placeholder = null,
  } = props;

  const [message, setMessage] = useState("");

  const handleSendMessage = (evt) => {
    evt.preventDefault();
    onSend(message);
    setMessage("");
  };

  return (
    <Form>
      <Form.Item>
        <Input
          autoComplete="off"
          className="send-input-user"
          name="chatMessage"
          placeholder={placeholder}
          value={message}
          onChange={(evt) => setMessage(evt.target.value)}
        />
        <Button
          htmlType="submit"
          type="primary"
          className="btn-right"
          icon={<FiSend />}
          loading={sendLoading}
          onClick={handleSendMessage}
        />
      </Form.Item>
    </Form>
  );
};

function stateToProps(state) {
  const { home, sending } = state;
  return {
    loading: home.loading,
    micOpen: home.micOpen,
    textResponse: sending.textResponse,
  };
}

function dispatchToProps(dispatch) {
  return {
    setMicOpen: (payload) => dispatch(setMicOpen(payload)),
    sendText: (payload) => dispatch(sendText(payload)),
    setQuestion: (payload) => dispatch(setQuestion(payload)),
  };
}

export default connect(stateToProps, dispatchToProps)(SpeechV2);
